<template>
  <Card style="min-width:350px">
    <h5 slot="title" style="cursor: pointer">
      <Icon type="ios-cube" />
      {{ title }}
    </h5>
    <Table width="500px" :columns="tableColumns" :data="tableData"></Table>
  </Card>
</template>

<script>
import expandDgLines from "./ExpandDgLines";

export default {
  name: "FreightLines",
  components: { expandDgLines },
  props: ["tableData", "hasDgs"],
  data() {
    return {
      title: "Freight",
      tableColumns: [
        {
          title: "Quantity",
          key: "quantity",
          width: 100,
          align: "center"
        },
        {
          title: "Package type",
          key: "packageType",
          tooltip: true,
          width: 200
        },
        {
          title: "Type of goods",
          key: "typeOfGoods",
          tooltip: true,
          width: this.typeOfGoodsWidth
        },
        {
          title: "Description",
          key: "description",
          width: 200
        },
        {
          title: "Weight (Kg)",
          key: "weight",
          width: 150
        },
        {
          title: "Volume (M³)",
          key: "volume",
          width: 150
        }
      ]
    };
  },

  computed: {
    typeOfGoodsWidth: function() {
      return this.hasDgs ? 230 : 260;
    }
  },

  watch: {
    hasDgs: function(hasDgs) {
      if (hasDgs) {
        this.tableColumns.unshift({
          type: "expand",
          width: 30,
          fixed: "left",
          render: (h, params) => {
            return h(expandDgLines, {
              props: {
                row: params.row.dgLines.data
              }
            });
          }
        });
      }
    }
  }
};
</script>

<style scoped></style>
